export default {
  state: {
    dealerSummaryReport: {},
  },

  mutations: {
    setDealerSummaryReport(state, payload) {
      state.dealerSummaryReport = payload;
    },
  },

  actions: {
    addDealerSummaryReport: ({ commit }, payload) => {
      commit('setDealerSummaryReport',  payload )
    },

  },
  
  getters: {
    dealerSummaryReport: state => state.dealerSummaryReport,
  },
}